{
  "version": 1,
  "asset_id": "2e854858-7cc7-4d0b-91dd-b5195d9e859a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2e854858-7cc7-4d0b-91dd-b5195d9e859a/mark-96.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2e854858-7cc7-4d0b-91dd-b5195d9e859a/mark-96.webp",
  "original_filename": "mark-96.webp",
  "size": 4478,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:18:44Z"
}
